<template>
  <div id="JumpPrompt">
    <div class="JumpPrompt-conent">
      <div @click="closeButton" class="img">
        <img src="@/assets/img/details/guanbi.png" alt="" />
      </div>
      <div class="h">即将离开中文知识网</div>
      <div class="conent">
        <p v-if="$route.query.title">
          <span>
            您即将进入{{
              $route.query.title
            }}，点击“继续访问”可查看具体内容。</span
          >
          <br />
        </p>
        <p v-else>
          <span> 您即将进入百科在线，点击“继续访问”可查看具体内容。</span>
          <br />
        </p>

        <span>
          中文知识网是国家知识服务平台融合出版分平台，是中文集团旗下子公司运营的知识服务平台。
          中文知识网拥有百家在线、百科在线、同行评议等子平台。请放心跳转。
        </span>
      </div>
      <div class="button">
        <span class="button-1" @click="close">不再提示</span>
        <span class="button-2" @click="goOn">继续访问</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JumpPrompt",
  components: {},
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    setCookie(name, value, seconds) {
      seconds = seconds || 0; //seconds有值就直接赋值，没有为0
      var expires = "";
      if (seconds != 0) {
        //设置cookie生存时间
        var date = new Date();
        date.setTime(date.getTime() + seconds * 1000);
        expires = "; expires=" + date.toGMTString();
      }
      document.cookie = name + "=" + escape(value) + expires + "; path=/"; //转码并赋值
    },
    // 关闭按钮X
    closeButton() {
      this.$emit("close");
    },
    // 不在提示
    close() {
      this.setCookie("close", true);
      localStorage.setItem("close", 1);
      this.$emit("close");
    },
    // 继续访问
    goOn() {
      this.$emit("close");
      switch (this.$route.query.title) {
        case "百家在线":
          window.open(`${this.$global.baijiaUrl}autherplain?id=${this.id}`);
          break;
        case "百科在线":
          window.open(`https://www.baikezaixian.com/details?ids=${this.id}`);
          break;
        case "机构号":
          break;
        default:
          window.open(`https://www.baikezaixian.com/details?ids=${this.id}`);
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
#JumpPrompt {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99;
  background: rgba($color: #000000, $alpha: 57%);
  .JumpPrompt-conent {
    padding: 0 38px 40px 45px;
    width: 500px;
    height: 300px;
    background: #fff;
    margin: 15% auto;
    border-radius: 8px;
    // position: relative;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%,-100%);
    .img {
      width: 26px;
      height: 26px;
      position: relative;
      right: -429px;
      cursor: pointer;
    }
    .h {
      margin-top: 0px;
      color: #3c3c3c;
      font-size: 18px;
      text-align: left;
      font-family: PingFangSC-Regular;
      font-weight: 600;
    }
    .conent {
      font-size: 14px;
      margin-top: 38px;
    }
    .button {
      height: 40px;
      float: right;
      margin-top: 50px;
      cursor: pointer;
      .button-1 {
        display: block;
        float: left;
        line-height: 35px;
        margin-right: 29px;
        color: #3c3c3c;
      }
      .button-2 {
        display: block;
        float: right;
        width: 100px;
        line-height: 35px;
        text-align: center;
        background: #007fff;
        border-radius: 4px;
        color: #fff;
      }
    }
  }
}
</style>
